import { motion } from "motion/react";
import { DURATION, EASE } from "@/components/motion/motion";
import { cn } from "@/lib/utils";

const draw = (delay = 0) => ({
	initial: { pathLength: 0 },
	whileInView: { pathLength: 1 },
	viewport: { once: true, margin: "0px 0px -15% 0px" },
	transition: { duration: DURATION.draw * 0.7, ease: EASE, delay },
});

const fadeIn = (delay = 0) => ({
	initial: { opacity: 0 },
	whileInView: { opacity: 1 },
	viewport: { once: true, margin: "0px 0px -15% 0px" },
	transition: { duration: 0.5, ease: EASE, delay },
});

const stroke = "stroke-foreground/60";

/** Small line drawings for the three activities: design, modernise, publish. */
export function PillarGlyph({
	kind,
	className,
}: {
	kind: "design" | "modernize" | "publish";
	className?: string;
}) {
	return (
		<svg
			viewBox="0 0 120 80"
			fill="none"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			className={cn("h-20 w-[7.5rem]", className)}
		>
			{kind === "design" ? (
				<>
					<motion.rect
						x="10"
						y="8"
						width="100"
						height="64"
						rx="8"
						className={stroke}
						{...draw()}
					/>
					<motion.path d="M10 22 H110" className={stroke} {...draw(0.3)} />
					<motion.path
						d="M34 22 V72"
						className={stroke}
						strokeDasharray="3 4"
						{...draw(0.5)}
					/>
					<motion.rect
						x="44"
						y="32"
						width="56"
						height="10"
						rx="3"
						className="fill-signal"
						{...fadeIn(1)}
					/>
					<motion.path
						d="M44 52 H92 M44 60 H80"
						className={stroke}
						{...draw(0.8)}
					/>
				</>
			) : kind === "modernize" ? (
				<>
					<motion.path
						d="M30 40 A30 30 0 0 1 84 22"
						className={stroke}
						{...draw()}
					/>
					<motion.path d="M84 10 V22 H72" className={stroke} {...draw(0.6)} />
					<motion.path
						d="M90 40 A30 30 0 0 1 36 58"
						className="stroke-signal"
						strokeWidth="2"
						{...draw(0.4)}
					/>
					<motion.path
						d="M36 70 V58 H48"
						className="stroke-signal"
						strokeWidth="2"
						{...draw(1)}
					/>
				</>
			) : (
				<>
					<motion.path d="M20 50 V68 H100 V50" className={stroke} {...draw()} />
					<motion.path
						d="M60 56 V12"
						className="stroke-signal"
						strokeWidth="2"
						{...draw(0.4)}
					/>
					<motion.path
						d="M44 28 L60 12 L76 28"
						className="stroke-signal"
						strokeWidth="2"
						{...draw(0.8)}
					/>
					<motion.circle
						cx="96"
						cy="16"
						r="6"
						className="fill-signal/20 stroke-signal"
						{...fadeIn(1.2)}
					/>
				</>
			)}
		</svg>
	);
}
